import { createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c6f1224")

_pushScopeId("data-v-4c6f1224")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("メインボタンの情報を編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm font-medium text-gray-500" }, " メインボタンを表示させる※チェックを外すとアプリ内でボタンが表示されなくなります ", -1)
const _hoisted_4 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_7 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm font-medium text-gray-500" }, " リンク先をアプリ内で開く※ チェックを外した場合は外部ブラウザで開きます ", -1)
const _hoisted_9 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("input", {
            id: "notification",
            type: "checkbox",
            checked: (_ctx.buttonIsDisplayed as boolean),
            name: "notification",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buttonIsDisplayed = !_ctx.buttonIsDisplayed))
          }, null, 40, ["checked"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "ボタンに表示される文言",
          name: "name",
          type: "text",
          value: _ctx.buttonValue,
          disabled: !_ctx.buttonIsDisplayed,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buttonValue = $event))
        }, null, 8, ["value", "disabled"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_m_text_field, {
          label: "ボタンから遷移するURL",
          name: "name",
          type: "text",
          value: _ctx.buttonLink,
          disabled: !_ctx.buttonIsDisplayed,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buttonLink = $event))
        }, null, 8, ["value", "disabled"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode("input", {
            id: "notification",
            type: "checkbox",
            checked: (_ctx.buttonIsWebView as boolean),
            name: "notification",
            disabled: !_ctx.buttonIsDisplayed,
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buttonIsWebView = !_ctx.buttonIsWebView))
          }, null, 40, ["checked", "disabled"])
        ])
      ])
    ]),
    footer: _withId(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.updateSetting
      }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
})